import { render, staticRenderFns } from "./PromotionStats.vue?vue&type=template&id=d2a60370&"
import script from "./PromotionStats.vue?vue&type=script&lang=js&"
export * from "./PromotionStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports